import * as api from './../../http'

export const ActionSetUtils = async ({ commit }) => {
  const utils = await api.http.get('dash/utils').then((response) => response.body)
  commit('SET_utils', utils)
}

export const ActionSetStates = async ({ commit }) => {
  const states = await api.http.get('dash/utils/states').then((response) => response.body)
  commit('SET_states', states)
}
export const ActionSetAuthorizations = async ({ commit }) => {
  const authorizations = await api.http
    .get('dash/utils/authorizations')
    .then((response) => response.body)
  commit('SET_authorizations', authorizations)
}

export const ActionSetPermissions = async ({ commit }) => {
  const permissions = await api.http.get('dash/utils/permissions').then((response) => response.body)
  commit('SET_permissions', permissions)
}

export const ActionSetStatus = async ({ commit }) => {
  const status = await api.http.get('dash/utils/status').then((response) => response.body)
  commit('SET_status', status)
}
export const ActionSetEmployeesDepartments = async ({ commit }) => {
  const departments = await api.http
    .get('dash/utils/employee_departments')
    .then((response) => response.body)
  commit('SET_employeesDepartments', departments)
}

export const ActionSetEmployeesFunctions = async ({ commit }) => {
  const employeeFunction = await api.http
    .get('dash/utils/employee_funcions')
    .then((response) => response.body)
  commit('SET_employeesFunctions', employeeFunction)
}

export const ActionEmployeesRoles = async ({ commit }) => {
  const roles = await api.http.get('dash/utils/employee_roles').then((response) => response.body)
  commit('SET_employeesRoles', roles)
}

export const ActionMaritalStatus = async ({ commit }) => {
  const maritalStatus = await api.http
    .get('dash/utils/marital_status')
    .then((response) => response.body)
  commit('SET_maritalStatus', maritalStatus)
}

export const ActionGenders = async ({ commit }) => {
  const genders = await api.http.get('dash/utils/genders').then((response) => response.body)
  commit('SET_genders', genders)
}

export const ActionSetMonthOfTheYear = async ({ commit }) => {
  const months = await api.http
    .get('dash/utils/months_of_the_year')
    .then((response) => response.body)
  commit('SET_monthsOfTheYear', months)
}
